<template>
	<div class="row">
		<div class="mr-auto ml-auto col-lg-10">
			<button @click="addNewProfile" class="btn btn-primary">
				<i class="fa fa-plus" aria-hidden="true" />
				{{ 'Create' | translate }} {{ franchiseText }}
			</button>
			<!-- <button class="btn btn-secondary">
        <i class="fa fa-file-excel-o" aria-hidden="true"/>
        {{ 'Download' | translate }}
      </button>
      <button
       :disabled='checkedProfile.length === 0'
       class="btn btn-secondary"
       @click.prevent='openModal(checkedProfile, "email")'>
        {{ 'Send email' | translate }}
      </button> -->
			<button :disabled="checkedProfile.length === 0" class="btn btn-secondary"
				@click.prevent="openModal(checkedProfile, 'bonus')">
				{{ 'Set bonus days' | translate }}
			</button>
			<div class="table-responsive">
				<table class="table">
					<tr>
						<!-- <th>
							<input
								@change="checkAll"
								v-model="checkAllInput"
								type="checkbox"
							/>
						</th> -->
						<th>ID</th>
						<th>{{ 'Payment Amount' | translate }}</th>
						<th>{{ 'Region' | translate }}</th>
						<th>{{ 'Person' | translate }}</th>
						<th>{{ 'Finances' | translate }}</th>
						<th>{{ 'Statistics' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr v-for="profile in listProfiles" :key="profile.id">
						<!-- <td>
							<input
								v-model="checkedProfile"
								:value="profile.id"
								type="checkbox"
								ref="input"
							/>
						</td> -->
						<td>{{ profile.id }}</td>
						<td>
							{{ profile.invoice.amount ? profile.invoice.amount : '0' }}
							{{ profile.currency | toSymbol }}
						</td>
						<td>{{ profile.region }}</td>
						<td>
							<router-link :to="{ name: 'Dashboard Profile', params: { id: profile.id } }">
								<div>{{ profile.last_name }}</div>
								<div>{{ profile.first_name }}</div>
								<div>{{ profile.middle_name }}</div>
							</router-link>
						</td>
						<td>
							<div>
								<span>{{ 'Royalty' | translate }}:</span>
								{{ profile.royalty | toInt }}%
							</div>
							<div>
								<span>{{ 'Turnover' | translate }}:</span>
							</div>
							<div>
								<span>{{ 'Discounts' | translate }}:</span>{{ getDiscounts(profile.discounts) }}
							</div>
							<div><span>PR:</span> {{ profile.pr_deposit | toInt }}%</div>
							<div>
								<span>{{ 'Сost of education' | translate }}:
									{{ profile.price_min | toInt
									}}{{ profile.currency | toSymbol }}</span>
							</div>
							<div v-if="profile.price_min_en !== null &&
				profile.price_min_en !== '0.00'
				">
								<span>{{ 'Сost of education' | translate }} EN:
									{{ profile.price_min_en | toInt
									}}{{ profile.currency | toSymbol }}</span>
							</div>
						</td>
						<td>
							<div>
								<span>{{ 'Students' | translate }}:</span>
								<router-link v-b-tooltip.hover :title="$t(`total`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'student' },
			}">{{ profile.statistic.students_total }}
								</router-link>
								/
								<router-link v-b-tooltip.hover :title="$t(`active`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'student' },
			}">{{ profile.statistic.students_active }}
								</router-link>
								/
								<router-link v-b-tooltip.hover :title="$t(`blocked`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id, is_active: false },
				params: { role: 'student' },
			}">{{ profile.statistic.students_inactive }}
								</router-link>
							</div>
							<div>
								<span>{{ 'Groups' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'group' },
			}">{{ profile.statistic.groups_total }}
								</router-link>
							</div>
							<div>
								<span>{{ 'Teachers' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'teacher' },
			}">{{ profile.statistic.teachers_total }}
								</router-link>
							</div>
							<div v-if="showFranchise">
								<span>{{ 'Franchise' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'franchise' },
			}">{{ profile.statistic.franchises_total }}
								</router-link>
							</div>
							<div>
								<span>{{ 'Parents' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'parent' },
			}">{{ profile.statistic.parents_total }}
								</router-link>
							</div>
						</td>
						<td>
							<router-link class="outline" :to="{ name: 'Dashboard Reports', params: { id: profile.id } }">{{ 'Finance'
				| translate }}
							</router-link>
							<router-link class="outline" :to="{
				name: 'Dashboard Reports',
				params: { id: profile.id },
				query: { tab: 'invoice' },
			}">{{ 'Send invoice' | translate }}
							</router-link>
							<a href="#" class="outline" @click.prevent="openModal(profile.id, 'email')">{{ 'Send email' | translate
								}}</a>
							<a href="#" @click.prevent="openModal(profile.id, 'delete')" class="text-red outline outline-red">{{
				'Block' | translate }}</a>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { toSymbol } from '@/helpers/filters'

export default {
	name: 'Franchise',
	data() {
		return {
			checkedProfile: [],
			checkAllInput: false,
			showFranchise: false,
		}
	},
	computed: {
		listProfiles() {
			return this.$store.state.profiles
		},
		franchiseText() {
			if (this.$route.params.role === 'franchise') {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.showFranchise = false
				return this.$t('Franchise')
			} else {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.showFranchise = true
				return this.$t('Master Franchise')
			}
		},
	},
	filters: {
		toSymbol,
		toInt(val) {
			if (val !== null && val !== undefined) {
				return parseInt(val)
			}
			return 0
		},
	},
	methods: {
		addNewProfile() {
			this.$router.push({
				name: 'Dashboard Add',
				params: { role: this.$route.params.role },
			})
		},
		getDiscounts(arr) {
			if (arr.length === 0) {
				return 0
			} else {
				let discountArr = []
				arr.forEach(item => {
					discountArr.push(item.discount)
				})
				return discountArr.join(', ')
			}
		},
		checkAll() {
			this.checkedProfile = []
			if (this.checkAllInput) {
				this.listProfiles.forEach(item => {
					this.checkedProfile.push(Number(item.id))
				})
			}
		},
		openModal(id, type) {
			if (typeof id === 'number') {
				let profileArr = []
				profileArr.push(id)
				this.$store.commit('changeModalId', profileArr)
			} else {
				this.$store.commit('changeModalId', id)
			}
			this.$store.commit('changeModalType', type)
			this.$emit('openModal')
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (max-width: 576px) {
	.offset-lg-1>.btn {
		width: 100%;
		margin-bottom: 10px;
	}
}
</style>
